import Icon from '@/components/common/iconedLinks/Icon';

export const DefaultWarningIcon = (props) => <Icon alt="warning" {...props}/>;
